import styled from "styled-components";
import { Flex } from "../Grid";
export const TextareaWrapperContainer = styled.span `
  position: relative;
  display: inline-block;
  width: ${({ width }) => width || "100%"};
`;
export const TextareaInput = styled.textarea `
  box-sizing: border-box;
  font-family: "Golos Text", serif;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding: 0.75rem 1rem;
  color: ${({ error }) => error ? "#F1274C" : "#000000"};
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "6rem"};
  background: ${({ disabled }) => disabled ? "#F3F3F3" : "transparent"};
  border: 1px solid ${({ isFocused, error }) => isFocused ? "#9D87F1" : error ? "#F1274C" : "#E3E3E3"};
  border-radius: 0.5rem;
  outline: ${({ isFocused }) => isFocused ? "4px solid #CEC3F8" : "none"};

  &:hover {
    border-color: ${({ disabled, error }) => !(disabled || error) && "#9F9F9F"};
  }
`;
export const TextareaLabel = styled(Flex) `
  align-items: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #9F9F9F;
  margin-bottom: 0.5rem;
`;
export const TextareaErrorMessage = styled.div `
  color: #F1274C;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin-top: 0.25rem;
`;
